import { ShirtspaceResponse } from "@services/shirtspace.types";
import React, { Suspense, useEffect, useRef } from "react";
import { Await } from "react-router-dom";
import { ProductBulkPricing } from "~/components/ProductBulkPricing";
import { ProductAvailability } from "~/entities/product/types";
import { SelectedVariant } from "~/entities/variant/types";

type ContainerProps = {
  isSignedIn: boolean;
  selectedVariant: SelectedVariant;
  productAvailability?: Promise<ShirtspaceResponse<ProductAvailability>>;
};

const Container: React.FC<ContainerProps> = ({
  productAvailability,
  isSignedIn,
  selectedVariant,
}) => {
  const previousSelectedVariant = useRef<SelectedVariant>(selectedVariant);
  const emptyFallback = useRef<React.ReactNode>(
    <ProductBulkPricing isLoading={true} />,
  );

  useEffect(() => {
    if (previousSelectedVariant.current === selectedVariant) {
      return;
    }

    previousSelectedVariant.current = selectedVariant;
  }, [selectedVariant]);

  return (
    <Suspense fallback={emptyFallback.current}>
      <Await resolve={productAvailability}>
        {(response: ShirtspaceResponse<ProductAvailability> | undefined) => {
          if (!response?.data) {
            return emptyFallback.current;
          }

          emptyFallback.current = (
            <ProductBulkPricing
              isSignedIn={isSignedIn}
              productAvailability={response.data}
              selectedVariant={previousSelectedVariant.current}
              isLoading={true}
            />
          );

          return (
            <ProductBulkPricing
              isSignedIn={isSignedIn}
              productAvailability={response.data}
              selectedVariant={selectedVariant}
            />
          );
        }}
      </Await>
    </Suspense>
  );
};

export default Container;
